var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('h4',[_vm._v(_vm._s(this.title))]),_c('p',[_vm._v(_vm._s(this.hour +":"+ this.minute))])])
}
var staticRenderFns = []

export { render, staticRenderFns }